import { Button, Modal } from "react-bootstrap";
import { Show } from "../../../../hooks/Show";
import { connect } from "react-redux";
import { FormProvider, useForm } from "react-hook-form";
import { SubCategoryModalForm } from "./SubCategoryModalForm";
import { useEffect, useState } from "react";

export const EditSubCategoryButtonComponent = ({
  isActive = false,
  idSubCategory = null,
  subCategory = null,
  successfulUpdateSubCategory = false,
  reduxGetSubCategoryById = () => {},
  reduxUpdateSubCategories = () => {},
}) => {
  const methods = useForm();

  const [openModalUpdateSubCategory, setOpenModalUpdateSubCategory] =
    useState(false);

  const isDirtyFields =
    methods.formState?.dirtyFields?.categoryId ||
    methods.formState?.dirtyFields?.subCategoryName;

  const isAvailableToSubmit =
    isDirtyFields &&
    methods.watch("categoryId") &&
    methods.watch("subCategoryName");

  const handleUpdateSubCategory = (data) => {
    reduxUpdateSubCategories({
      id: idSubCategory,
      subCategoryName: data.subCategoryName.trim(),
      idCategory: data.categoryId,
    });
  };

  const handleOpenModalUpdateSubCategory = () => {
    setOpenModalUpdateSubCategory(true);
    reduxGetSubCategoryById({ id: idSubCategory });
  };

  const handleCloseModalUpdateSubCategory = () => {
    setOpenModalUpdateSubCategory(false);
    methods.reset();
  };

  useEffect(() => {
    if (!openModalUpdateSubCategory) return;
    if (!subCategory) return;

    methods.reset({
      categoryId: subCategory.idCategory,
      subCategoryCode: subCategory.subCategoryCode,
      subCategoryName: subCategory.subCategoryName,
    });
  }, [openModalUpdateSubCategory, subCategory]);

  useEffect(() => {
    if (successfulUpdateSubCategory) {
      methods.reset();
      setOpenModalUpdateSubCategory(false);
    }
  }, [successfulUpdateSubCategory]);

  if (!isActive) return null;

  return (
    <>
      <Show when="feature:wms-subcategories-edit">
        <button
          title="Editar"
          className="btn btn-primary btn-sm btn-circle mr-2"
          type="button"
          onClick={handleOpenModalUpdateSubCategory}
        >
          <i className="fas fa-edit fa-xs"></i>
        </button>
      </Show>
      <Modal
        size="xl"
        show={openModalUpdateSubCategory}
        onHide={handleCloseModalUpdateSubCategory}
        onEscapeKeyDown={handleCloseModalUpdateSubCategory}
        backdrop="static"
        keyboard={true}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Editar Subcategoría {subCategory?.subCategoryName || ""}
          </Modal.Title>
        </Modal.Header>
        <FormProvider {...methods}>
          <form onSubmit={methods.handleSubmit(handleUpdateSubCategory)}>
            <Modal.Body>
              <SubCategoryModalForm isEdit />
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={handleCloseModalUpdateSubCategory}
              >
                Cancelar
              </Button>
              <Button
                variant="primary"
                type="submit"
                disabled={!isAvailableToSubmit}
              >
                Guardar Cambios
              </Button>
            </Modal.Footer>
          </form>
        </FormProvider>
      </Modal>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    subCategory: state.subCategoriesState.rowEdited,
    successfulUpdateSubCategory:
      state.subCategoriesState.successfulUpdateSubCategory,
    errorsUpdateSubCategory: state.subCategoriesState.errorsUpdateSubCategory,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    reduxGetSubCategoryById: (payload) =>
      dispatch({
        type: "READ_SUB_CATEGORY_REQUEST",
        value: payload,
      }),
    reduxUpdateSubCategories: (payload) =>
      dispatch({
        type: "UPDATE_SUB_CATEGORY_REQUEST",
        value: payload,
      }),
  };
};

export const EditSubCategoryButton = connect(
  mapStateToProps,
  mapDispatchToProps,
)(EditSubCategoryButtonComponent);
